/******************************************************************************************
 *	Date Directive through which all RC dates pass
 *******************************************************************************************
 *
 * Dates are expected to be strings formatted as ISO-8601 date syntax.
 * For example: 1994-11-05T08:15:30-05:00.
 *
 */
(function() {
  

  //Parse string date and update scope properties
  function updateScope(_, scope, defaultFormat) {
    //Reset displayDate so that it doesn't persist between scope updates
    scope.displayDate = null;

    if (scope.date && _.isString(scope.date)) {
      var localDate = new Date(scope.date);
      if (localDate) {
        var parts = _.split(scope.date, 'T');
        var ymd = _.split(parts[0], '-');
        if (ymd.length === 3) {
          //Create a date object without the time or time zone information so that conversion to local time is avoided
          var year = ymd[0];
          var month = parseInt(ymd[1], 10) - 1; //Month numbering is 0-based
          var day = ymd[2];

          //Expose displayDate, tooltip and format to scope
          scope.displayDate = new Date(year, month, day);
          scope.tooltip = localDate;
          scope.format = scope.dateFormat || defaultFormat;
        }
      }
    }

    //If scope.displayDate isn't set, the input was invalid and could not be parsed into a Date object.
    //In this case, just fallback to the originally passed-in scope.date
    if (!scope.displayDate) {
      scope.displayDate = scope.date;
    }
  }

  angular.module('rcDirectives.date', []).directive(
    'rcDate',
    /* @ngInject */
    function(_, Settings) {
      return {
        restrict: 'A',
        replace: true,
        scope: {
          date: '@',
          dateFormat: '@'
        },
        templateUrl: 'templates/date.html',
        link: function(scope) {
          //Read initial date
          updateScope(_, scope, Settings.DEFAULT_DATE_FORMAT);

          //Respond to live date changes
          scope.$watch('date', function() {
            updateScope(_, scope, Settings.DEFAULT_DATE_FORMAT);
          });
        }
      };
    }
  );
})();
